var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevious({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4038 4.34851H2.43065L5.55433 1.22568C5.83323 0.945935 5.83323 0.489554 5.55433 0.209809C5.27459 -0.0699363 4.81736 -0.0699363 4.53846 0.209809L0.208752 4.53867C0.0676121 4.68066 -0.000845151 4.86828 0.0016903 5.05591C0.0016903 5.06013 0 5.06351 0 5.06689V5.06774C0 5.07281 0.0033806 5.07872 0.0033806 5.08464C0.00591606 5.17254 0.0219739 5.25959 0.05578 5.34241C0.0769088 5.39228 0.11325 5.43284 0.145366 5.47764C0.168185 5.50891 0.180862 5.54609 0.208752 5.57398L4.53846 9.90285C4.81736 10.1817 5.27459 10.1817 5.55433 9.90285C5.83323 9.6231 5.83323 9.16588 5.55433 8.88698L2.45263 5.78527H10.4038C10.7993 5.78527 11.1222 5.46158 11.1222 5.06774C11.1222 4.67221 10.7993 4.34851 10.4038 4.34851Z",
    fill: "#EAA827"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevious);
export default __webpack_public_path__ + "static/media/previous.ab90879c7aa7f2e9166c3fa57241cafc.svg";
export { ForwardRef as ReactComponent };